import { render, staticRenderFns } from "./BumpOrder.vue?vue&type=template&id=244c837c&scoped=true"
import script from "./BumpOrder.vue?vue&type=script&lang=js"
export * from "./BumpOrder.vue?vue&type=script&lang=js"
import style0 from "./BumpOrder.vue?vue&type=style&index=0&id=244c837c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c837c",
  null
  
)

export default component.exports